import React from "react";
import { media } from "src/theme";
import styled from "styled-components";

import { translate } from "../../services/translation.service";

const LoaderWrapper = styled.div`
  display: flex;
  flex: 1;
  margin: 50% 0;
  justify-content: center;
  align-items: center;

  ${media.laptop} {
    margin: 25% 0;
  }
`;

export default (): JSX.Element => (
  <LoaderWrapper>{translate("error.errorOccurred")}</LoaderWrapper>
);
